// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fahrten-container {
  max-width: 1100px;
}

.fahrten-container .logistik-tabs {
  margin-bottom: 1rem;
}

.fahrten-container .logistik-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.logistik-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.3rem;
  height: 1.3rem;
  border-radius: 999px;
  background: var(--logistik-hell);
  color: var(--logistik);
  font-family: 'Circular', sans-serif;
  font-size: 0.75rem;
  line-height: 1;
  padding: 0 0.3rem;
}

.logistik-tab.active .logistik-tab-count {
  background: var(--weiss);
  color: var(--logistik);
}

/* Tabelle — folgt dem CI-Tabellenmuster (.ci-table), Header in Logistik-Farbe */
.fahrten-table-wrapper {
  overflow-x: auto;
  margin-bottom: 0.5rem;
}

.fahrten-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: var(--hellgruen);
  border-radius: 12px;
  overflow: hidden;
  font-family: 'Circular', sans-serif;
}

.fahrten-table thead tr {
  background: var(--logistik);
}

.fahrten-table th {
  padding: 0.75rem;
  text-align: left;
  font-family: 'Staatliches', sans-serif;
  font-size: calc(1rem + 2px);
  font-weight: normal;
  text-transform: uppercase;
  color: var(--blassgruen);
  white-space: nowrap;
}

.fahrten-table td {
  padding: 0.75rem;
  border: none;
  vertical-align: top;
  font-size: calc(1rem - 1px);
  color: var(--dunkelgruen);
}

.fahrten-table tbody tr:nth-child(even):not(.fahrt-edit-row) {
  background-color: var(--blassgruen);
}

.col-nr {
  width: 3rem;
  text-align: center;
  font-weight: 600;
}

.col-abfahrt {
  white-space: nowrap;
}

.col-adresse {
  color: var(--dunkelgruen);
}

.col-infos {
  color: var(--dunkelgruen);
  max-width: 260px;
  min-width: 11rem;
}

.col-order {
  width: 4rem;
}

.col-actions {
  width: 6rem;
}

/* Reihenfolge-Buttons */
.order-btn {
  background: var(--logistik-hell) !important;
  color: var(--logistik) !important;
  border: none;
  border-radius: 6px !important;
  padding: 0.15rem 0.4rem !important;
  cursor: pointer;
  font-size: 0.9rem !important;
  min-height: auto !important;
  margin: 0 1px;
  line-height: 1.4;
}

.order-btn:hover:not(:disabled) {
  background: var(--logistik-hell-hover) !important;
}

.order-btn:disabled {
  opacity: 0.3;
  cursor: default;
}

.fahrten-container button:disabled,
.fahrten-container .logistik-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Edit-Zeile */
.fahrt-edit-row td {
  padding: 0;
  background: var(--logistik-blass);
}

/* Formular */
.fahrt-form {
  padding: 1rem 1.25rem;
  background: var(--logistik-blass);
}

.fahrt-form-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem 1rem;
}

.fahrt-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.fahrt-field label {
  font-family: 'Staatliches', sans-serif;
  font-size: 1rem;
  color: var(--logistik);
  text-transform: uppercase;
}

.fahrt-field textarea.logistik-input {
  resize: vertical;
  min-height: 2.5rem;
}

.fahrt-nr-input {
  width: 5rem !important;
}

.span-2 {
  grid-column: span 2;
}

.fahrt-form-actions {
  margin-top: 0.75rem;
}

.fahrten-container .logistik-print-link,
.fahrten-container .logistik-print-link .print-text,
.fahrten-container .logistik-print-link .material-symbols-outlined {
  color: var(--logistik) !important;
}

/* Druckansicht */
@media print {
  .fahrten-table {
    font-size: 0.85rem;
  }

  .fahrten-table th,
  .fahrten-table td {
    padding: 0.35rem 0.45rem;
  }

  .fahrten-table thead tr {
    background: var(--logistik) !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}

@media (max-width: 700px) {
  .fahrt-form-grid {
    grid-template-columns: 1fr 1fr;
  }

  .span-2 {
    grid-column: span 2;
  }

  .fahrten-table,
  .fahrten-table thead,
  .fahrten-table tbody,
  .fahrten-table tr,
  .fahrten-table th,
  .fahrten-table td {
    display: block;
  }

  .fahrten-table thead {
    display: none;
  }

  .fahrten-table {
    background: transparent;
  }

  .fahrten-table tbody tr.fahrt-row {
    background: var(--weiss) !important;
    border-radius: 12px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
    margin-bottom: 0.65rem;
    overflow: hidden;
  }

  .fahrten-table td {
    display: grid;
    grid-template-columns: 7.5rem minmax(0, 1fr);
    gap: 0.65rem;
    padding: 0.55rem 0.75rem;
    border-bottom: 1px solid var(--logistik-hell);
  }

  .fahrten-table td::before {
    content: attr(data-label);
    color: var(--logistik);
    font-family: 'Staatliches', sans-serif;
  }

  .fahrten-table .col-order,
  .fahrten-table .col-actions {
    display: flex;
    justify-content: flex-start;
    border-bottom: none;
  }

  .fahrten-table .col-order::before,
  .fahrten-table .col-actions::before {
    content: none;
  }

  .fahrt-edit-row td {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/logistik/fahrten/Fahrten.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,gFAAgF;AAChF;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,sCAAsC;IACtC,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;;;;IAME,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,yCAAyC;IACzC,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,4CAA4C;IAC5C,YAAY;IACZ,wBAAwB;IACxB,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,sCAAsC;EACxC;;EAEA;;IAEE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".fahrten-container {\n  max-width: 1100px;\n}\n\n.fahrten-container .logistik-tabs {\n  margin-bottom: 1rem;\n}\n\n.fahrten-container .logistik-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.logistik-tab-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.3rem;\n  height: 1.3rem;\n  border-radius: 999px;\n  background: var(--logistik-hell);\n  color: var(--logistik);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.75rem;\n  line-height: 1;\n  padding: 0 0.3rem;\n}\n\n.logistik-tab.active .logistik-tab-count {\n  background: var(--weiss);\n  color: var(--logistik);\n}\n\n/* Tabelle — folgt dem CI-Tabellenmuster (.ci-table), Header in Logistik-Farbe */\n.fahrten-table-wrapper {\n  overflow-x: auto;\n  margin-bottom: 0.5rem;\n}\n\n.fahrten-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background-color: var(--hellgruen);\n  border-radius: 12px;\n  overflow: hidden;\n  font-family: 'Circular', sans-serif;\n}\n\n.fahrten-table thead tr {\n  background: var(--logistik);\n}\n\n.fahrten-table th {\n  padding: 0.75rem;\n  text-align: left;\n  font-family: 'Staatliches', sans-serif;\n  font-size: calc(1rem + 2px);\n  font-weight: normal;\n  text-transform: uppercase;\n  color: var(--blassgruen);\n  white-space: nowrap;\n}\n\n.fahrten-table td {\n  padding: 0.75rem;\n  border: none;\n  vertical-align: top;\n  font-size: calc(1rem - 1px);\n  color: var(--dunkelgruen);\n}\n\n.fahrten-table tbody tr:nth-child(even):not(.fahrt-edit-row) {\n  background-color: var(--blassgruen);\n}\n\n.col-nr {\n  width: 3rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n.col-abfahrt {\n  white-space: nowrap;\n}\n\n.col-adresse {\n  color: var(--dunkelgruen);\n}\n\n.col-infos {\n  color: var(--dunkelgruen);\n  max-width: 260px;\n  min-width: 11rem;\n}\n\n.col-order {\n  width: 4rem;\n}\n\n.col-actions {\n  width: 6rem;\n}\n\n/* Reihenfolge-Buttons */\n.order-btn {\n  background: var(--logistik-hell) !important;\n  color: var(--logistik) !important;\n  border: none;\n  border-radius: 6px !important;\n  padding: 0.15rem 0.4rem !important;\n  cursor: pointer;\n  font-size: 0.9rem !important;\n  min-height: auto !important;\n  margin: 0 1px;\n  line-height: 1.4;\n}\n\n.order-btn:hover:not(:disabled) {\n  background: var(--logistik-hell-hover) !important;\n}\n\n.order-btn:disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.fahrten-container button:disabled,\n.fahrten-container .logistik-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Edit-Zeile */\n.fahrt-edit-row td {\n  padding: 0;\n  background: var(--logistik-blass);\n}\n\n/* Formular */\n.fahrt-form {\n  padding: 1rem 1.25rem;\n  background: var(--logistik-blass);\n}\n\n.fahrt-form-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem 1rem;\n}\n\n.fahrt-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.fahrt-field label {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1rem;\n  color: var(--logistik);\n  text-transform: uppercase;\n}\n\n.fahrt-field textarea.logistik-input {\n  resize: vertical;\n  min-height: 2.5rem;\n}\n\n.fahrt-nr-input {\n  width: 5rem !important;\n}\n\n.span-2 {\n  grid-column: span 2;\n}\n\n.fahrt-form-actions {\n  margin-top: 0.75rem;\n}\n\n.fahrten-container .logistik-print-link,\n.fahrten-container .logistik-print-link .print-text,\n.fahrten-container .logistik-print-link .material-symbols-outlined {\n  color: var(--logistik) !important;\n}\n\n/* Druckansicht */\n@media print {\n  .fahrten-table {\n    font-size: 0.85rem;\n  }\n\n  .fahrten-table th,\n  .fahrten-table td {\n    padding: 0.35rem 0.45rem;\n  }\n\n  .fahrten-table thead tr {\n    background: var(--logistik) !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n}\n\n@media (max-width: 700px) {\n  .fahrt-form-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .span-2 {\n    grid-column: span 2;\n  }\n\n  .fahrten-table,\n  .fahrten-table thead,\n  .fahrten-table tbody,\n  .fahrten-table tr,\n  .fahrten-table th,\n  .fahrten-table td {\n    display: block;\n  }\n\n  .fahrten-table thead {\n    display: none;\n  }\n\n  .fahrten-table {\n    background: transparent;\n  }\n\n  .fahrten-table tbody tr.fahrt-row {\n    background: var(--weiss) !important;\n    border-radius: 12px;\n    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);\n    margin-bottom: 0.65rem;\n    overflow: hidden;\n  }\n\n  .fahrten-table td {\n    display: grid;\n    grid-template-columns: 7.5rem minmax(0, 1fr);\n    gap: 0.65rem;\n    padding: 0.55rem 0.75rem;\n    border-bottom: 1px solid var(--logistik-hell);\n  }\n\n  .fahrten-table td::before {\n    content: attr(data-label);\n    color: var(--logistik);\n    font-family: 'Staatliches', sans-serif;\n  }\n\n  .fahrten-table .col-order,\n  .fahrten-table .col-actions {\n    display: flex;\n    justify-content: flex-start;\n    border-bottom: none;\n  }\n\n  .fahrten-table .col-order::before,\n  .fahrten-table .col-actions::before {\n    content: none;\n  }\n\n  .fahrt-edit-row td {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
